module.exports = __webpack_public_path__ + "img/water_75.22f170ee.gif";